module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-common noselect"
  }, [_c('div', {
    staticClass: "body-common"
  }, [_c('div', {
    staticClass: "card card-common",
    class: {
      locked: !_vm.salarieCourant.IsCurrent
    }
  }, [_c('div', {
    staticClass: "card-body d-flex position-relative"
  }, [_c('div', {
    staticClass: "border-right pr-3 d-flex flex-column justify-content-between"
  }, [_c('button', {
    staticClass: "inp-button-circle big",
    attrs: {
      "type": "button",
      "title": _vm.salarieCourant.LibelleSalarieActifPrecedent,
      "disabled": _vm.salarieCourant.IdSalarieActifPrecedent == undefined || !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.navigueSalarie(_vm.salarieCourant.IdSalarieActifPrecedent, _vm.salarieCourant.LibelleSalarieActifPrecedent)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-circle big",
    attrs: {
      "type": "button",
      "title": _vm.salarieCourant.LibelleSalarieActifSuivant,
      "disabled": _vm.salarieCourant.IdSalarieActifSuivant == undefined || !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.navigueSalarie(_vm.salarieCourant.IdSalarieActifSuivant, _vm.salarieCourant.LibelleSalarieActifSuivant)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-right"
  })])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('img', {
    attrs: {
      "alt": "Photo",
      "src": _vm.srcImage
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row flex-grow-1 no-gutters"
  }, [_c('div', {
    staticClass: "col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-info-1 border-right pr-3"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "tw-flex tw-flex-col tw-justify-between wrapper h-100"
  }, [_c('div', {
    staticClass: "row tw-h-fit no-gutters d-flex w-100 ml-3 pr-3"
  }, [_c('div', {
    staticClass: "col col-12 d-flex flex-row",
    attrs: {
      "title": _vm.salarieCourant.FullName
    }
  }, [(_vm.salarieCourant.Civilite == 'Madame') ? _c('span', {
    staticClass: "sub"
  }, [_vm._v("Mme")]) : _c('span', {
    staticClass: "sub"
  }, [_vm._v("M.")]), _vm._v(" "), _c('span', {
    staticClass: "text ml-1"
  }, [_vm._v(_vm._s(_vm.salarieCourant.FullName))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-12 d-flex flex-row",
    attrs: {
      "title": _vm.salarieCourant.NomNaissance
    }
  }, [(_vm.salarieCourant.Civilite == 'Madame') ? _c('span', {
    staticClass: "sub"
  }, [_vm._v("Née")]) : _c('span', {
    staticClass: "sub"
  }, [_vm._v("Né")]), _vm._v(" "), _c('span', {
    staticClass: "text ml-1"
  }, [_vm._v(_vm._s(_vm.salarieCourant.NomNaissance))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-12 d-flex flex-row",
    attrs: {
      "title": _vm.salarieCourant.NumeroSalarie
    }
  }, [_c('span', {
    staticClass: "sub"
  }, [_vm._v("N°")]), _vm._v(" "), _c('span', {
    staticClass: "text ml-1"
  }, [_vm._v(_vm._s(_vm.salarieCourant.NumeroSalarie))])])]), _vm._v(" "), _c('div', {
    staticClass: "row tw-h-fit no-gutters d-flex w-100 ml-3 pr-3 align-items-end"
  }, [_c('div', {
    staticClass: "col col d-flex flex-row h-100"
  }, [_c('Button', {
    staticClass: "pl-0",
    attrs: {
      "icon": "fas fa-envelope",
      "title": "Email",
      "text": "Email"
    },
    on: {
      "click": function($event) {
        _vm.sendMail()
      }
    }
  })], 1)])]) : _c('loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-info-2 border-right pr-3"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "wrapper h-100"
  }, [_c('div', {
    staticClass: "row no-gutters ml-3"
  }, [_c('div', {
    staticClass: "col col-6 pr-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.DateEntreeContrat == undefined || _vm.salarieCourant.DateEntreeContrat == '') ? 'text-info' : '',
    attrs: {
      "title": "Date entrée"
    }
  }, [_vm._v("Date entrée")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm._f("moment")(_vm.salarieCourant.DateEntreeContrat, 'DD/MM/YYYY')
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.salarieCourant.DateEntreeContrat, "DD/MM/YYYY")))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 pl-2"
  }, [_c('div', {
    staticClass: "title",
    class: _vm.salarieCourant.DateAnciennete == undefined ? 'text-info' : '',
    attrs: {
      "title": "Ancienneté étude"
    }
  }, [_vm._v("Date d'ancienneté")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm._f("moment")(_vm.salarieCourant.DateAnciennete, 'DD/MM/YYYY')
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.salarieCourant.DateAnciennete, "DD/MM/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters ml-3"
  }, [_c('div', {
    staticClass: "col col-6 pr-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.DateSortieContrat == undefined || _vm.salarieCourant.DateSortieContrat == '') ? 'text-info' : '',
    attrs: {
      "title": "Date sortie"
    }
  }, [_vm._v("Date sortie")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm._f("moment")(_vm.salarieCourant.DateSortieContrat, 'DD/MM/YYYY')
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.salarieCourant.DateSortieContrat, "DD/MM/YYYY")))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 pl-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.ancienneteNotariat == undefined || _vm.ancienneteNotariat == '') ? 'text-info' : '',
    attrs: {
      "title": "Ancienneté notariat"
    }
  }, [_vm._v("Ancienneté notariat")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.ancienneteNotariat
    }
  }, [_vm._v(_vm._s(_vm.ancienneteNotariat))])])])]) : _c('loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-info-3 border-right pr-3"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "wrapper h-100"
  }, [_c('div', {
    staticClass: "row no-gutters ml-3"
  }, [_c('div', {
    staticClass: "col col-6 pr-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.TypeContrat == undefined || _vm.salarieCourant.TypeContrat == '') ? 'text-info' : '',
    attrs: {
      "title": "Type contrat"
    }
  }, [_vm._v("Type contrat")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.salarieCourant.TypeContrat
    }
  }, [_vm._v(_vm._s(_vm.salarieCourant.TypeContrat))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 pl-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.NumeroContrat == undefined || _vm.salarieCourant.NumeroContrat == '') ? 'text-info' : '',
    attrs: {
      "title": "N° Contrat"
    }
  }, [_vm._v("N° Contrat")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.salarieCourant.NumeroContrat
    }
  }, [_vm._v(_vm._s(_vm.salarieCourant.NumeroContrat))])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters ml-3"
  }, [_c('div', {
    staticClass: "col col-6 pr-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.NatureContrat == undefined || _vm.salarieCourant.NatureContrat == '') ? 'text-info' : '',
    attrs: {
      "title": "Nature contrat"
    }
  }, [_vm._v("Nature contrat")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.salarieCourant.NatureContrat
    }
  }, [_vm._v(_vm._s(_vm.salarieCourant.NatureContrat))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 pl-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.NumeroCRPCEN == undefined || _vm.salarieCourant.NumeroCRPCEN == '') ? 'text-info' : '',
    attrs: {
      "title": "N° CRPCEN"
    }
  }, [_vm._v("N° CRPCEN")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.salarieCourant.NumeroCRPCEN
    }
  }, [_vm._v(_vm._s(_vm.salarieCourant.NumeroCRPCEN))])])])]) : _c('loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-info-4 pr-3"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "wrapper h-100"
  }, [_c('div', {
    staticClass: "row no-gutters ml-3"
  }, [_c('div', {
    staticClass: "col col-6 pr-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.numeroTelFixe == undefined || _vm.numeroTelFixe == '') ? 'text-info' : '',
    attrs: {
      "title": "Fixe"
    }
  }, [_vm._v("Fixe")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.numeroTelFixe
    }
  }, [_vm._v(_vm._s(_vm.numeroTelFixe))])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 pl-2"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.numeroTelMobile == undefined || _vm.numeroTelMobile == '') ? 'text-info' : '',
    attrs: {
      "title": "Mobile"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.numeroTelMobile
    }
  }, [_vm._v(_vm._s(_vm.numeroTelMobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters ml-3"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "title",
    class: (_vm.salarieCourant.EMail == undefined || _vm.salarieCourant.EMail == '') ? 'text-info' : '',
    attrs: {
      "title": "E-mail pro"
    }
  }, [_vm._v("E-MAIL PRO")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.salarieCourant.EMail
    }
  }, [_vm._v(_vm._s(_vm.salarieCourant.EMail))])])])]) : _c('loader')], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4a25ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/common/commonSalarie.vue.html
// module id = DxwC
// module chunks = 2